import React, { useState } from "react";
import { UserPlus } from "lucide-react";
import styles from "./WorkBagHeader.module.scss";

interface WorkBagHeaderProps {
  onInscribirme: (email?: string) => void;
}

const WorkBagHeader: React.FC<WorkBagHeaderProps> = ({
  onInscribirme,
}) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onInscribirme(email.trim() || undefined);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <p className={styles.kicker}>Bolsa de trabajo</p>
        <h1 className={styles.title}>
        Encontrá ofertas en construcción y registrate para postular
        </h1>
        <form onSubmit={handleSubmit} className={styles.form}>
          <input
            type="email"
            placeholder="tu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={styles.emailInput}
            aria-label="Email para registrarse"
          />
          <button type="submit" className={styles.inscribirmeButton}>
            <UserPlus size={20} />
            Inscribirme
          </button>
        </form>
      </div>
    </header>
  );
};

export default WorkBagHeader;
